import { ToolBar, ToolBarCustomButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect.js";
import { Region } from "../core/components/region.js";
import { Menu, MouseButton, MenuEntry, EntryType } from "../core/components/menu.js";
import { VerticalTabsStripFloatingContent, VerticalTabStrip } from "../core/components/verticalTabStrip.js";
import { PageTitle } from "../core/components/pageTitle.js";
import { SimpleRadioButton } from "../core/components/simpleRadioButton.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType, Sheet } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { RightDrawerContainer } from "../core/components/rightDrawerContainer.js";
import { ModuleLicenseTable, CurrentLicensePackageInformation, ContainedLicense, LicenseActivationStatus, ActivationStatus } from "../userSettings/userModuleAllocation.js";
import { Entity, Metadata } from "../core/components/commonApp.js";
import { IntKeyDictionary, StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";

const renderRegion = (title: string, content) => {
    return (
        <Region title={title}>
            <div style={{ padding: "10px", lineHeight: "120%" }}>
                {content}
            </div>
        </Region>
    );
}

const getCellTemplate = (name: string, forceValueWhenNull: boolean) => {
    const field = name;
    const valueCheck = field + "=== true ?";
    const parts = name.split(".");
    const licName = parts[parts.length - 1];

    const common = "<label data-prop='" + licName + "' style='display:flex;justify-content:center;padding:0 7px;'><span style='font-size:14px;color:#=" + valueCheck + "\"limegreen\":\"red\"#'>#="

    return forceValueWhenNull ?
        (common + valueCheck + "\"✓\" : \"✗\"#<span/></label>")
        :
        (common + field + " === null ? '' : (" + valueCheck + "\"✓\" : \"✗\")#</span></label>");
}

const getLicenseModel = (licensePackage: CurrentLicensePackageInformation, selectedUsers: Array<SelectedUser>) => {
    const model: Array<ModuleData> = [];

    licensePackage.ContainedLicenses.forEach(l => {
        model.push({
            //enabled: false,
            id: l.Id,
            name: l.Name,
            propertyName: l.Name.replace(/(\W|\d|_|-|\+)/g, ""),//convert spaces, numbers and some symbols (list is incomplete; add if needed...) to empty string,
            initialInstances: {
                active: 0,
                notActive: 0
            },
            changeState: ActivationStatus.NotSet,
            dirty: false
        });
    });

    if (Array.isArray(selectedUsers)) {
        selectedUsers.forEach(u => {
            model.forEach(l => {
                if (u.CurrentLicenses[l.propertyName] === true) {
                    l.initialInstances.active++;
                } else {
                    l.initialInstances.notActive++;
                }
            });
        });

        model.forEach(l => {
            if (l.initialInstances.active === selectedUsers.length) {
                l.changeState = ActivationStatus.On;
            } else if (l.initialInstances.notActive === selectedUsers.length) {
                l.changeState = ActivationStatus.Off;
            }
        });
    }

    return model;
}


export class ModuleRightsApp extends React.Component<ModuleRightsAppProps, ModuleRightsAppState> {
    private _markedModuleName: string = null;
    private _rightsTabActive = false;
    //menu
    private _menuDataSource: Array<MenuEntry> = [{
        type: EntryType.Save,
        onClick: "save"
    }];
    private _menuRef: Menu = null;
    //grid
    private _userTableRef: UserTable = null;
    //data
    private _baseUrlList: Array<any> = [];
    private _baseUrl: string;
    private _rightDrawerContainer: any;
    private _sheet: Sheet = null;
    private _selectData = {
        logins: [] as Array<string>,
        groups: [] as Array<number>,
        mainGroups: [] as Array<number>,
    }


    constructor(props: ModuleRightsAppProps) {
        super(props);

        this._sheet = General.Sheet.Manager.getTopMostSheet();
        this._sheet.setUpUnloadHelper();

        this.state = {
            licenseInfo: props.licenseInfo,
            licenseSummary: getLicenseModel(props.licenseInfo, null),
            selectedUsers: [],
            userChangeTimestamp: null,
            userSelectMode: UserFilterType.NotSet
        };
    }


    //rendering

    private _renderRightDrawerComponent = () => {
        let metaDataAdditional = this.props.metadata.rightDrawerContainer.multipleComponents[0];
        this._rightDrawerContainer = metaDataAdditional != null ? metaDataAdditional as any : null;
        let tabUrls = this.props.metadata.additional.objects.filter((v) => v.name == "helpUrl");
        this._baseUrlList = tabUrls[0].data.helpUrls
        if (this._rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };
            let helpUrl;
            if ((this._baseUrl !== this._rightDrawerContainer.props.url) && (this._baseUrl != null)) {
                helpUrl = {
                    url: this._baseUrl
                };
            } else {
                helpUrl = {
                    url: this._rightDrawerContainer.props.url
                };
            }
            return <RightDrawerContainer
                moduleName={"app/core/components/iframe"}
                appName={undefined}
                visible={true}
                width={400}
                customProps={helpUrl}
                entity={entity}
                renderAlways={true}
                multipleComponents={undefined}
            />
        }

        return null;
    }

    private _renderLicenseTable = () => {
        const model: Array<LicenseActivationStatus> =
            this.state.licenseSummary
                .map(l => {
                    return {
                        id: l.id,
                        activationStatus: l.changeState
                    };
                });

        const usage: IntKeyDictionary<number> = {};
        this.state.licenseSummary.forEach(lic => {
            usage[lic.id] = lic.initialInstances.active
        });

        return (
            <ModuleLicenseTable
                lastSaveTimestamp={this.state.userChangeTimestamp}
                model={model}
                numberOfUsers={this.state.selectedUsers.length}
                licenseUsage={usage}
                onChange={this._onSelectedModulesChanged}
                onLicenseClick={this._onLicenseClick}
                onLicenseMouseEnter={l => { this._onLicenseHover(l, true) }}
                onLicenseMouseLeave={l => { this._onLicenseHover(l, false) }}
                package={this.state.licenseInfo}
                readonly={this.state.selectedUsers.length === 0}
                translations={{
                    expiredLicenses: this.props.translations.LBL_EXPIRED_LICENSES,
                    off: this.props.translations.LBL_OFF,
                    on: this.props.translations.LBL_ON
                }}
            />
        );
    }

    //end rendering


    //refs

    private _onMenuRef = (ref) => {
        this._menuRef = ref;
    }

    private _onUserTableRef = (ref) => {
        this._userTableRef = ref;
    }

    //end ref

    //events

    private _onSelectedModulesChanged = (modules: Array<LicenseActivationStatus>) => {
        this.setState(({ licenseInfo, licenseSummary, selectedUsers, userChangeTimestamp, userSelectMode }, props) => {
            licenseSummary.forEach(l => {
                const module = Helper.getArrayItem(modules, "id", l.id);

                if (l.changeState !== module.activationStatus) {
                    l.dirty = true;
                    l.changeState = module.activationStatus;

                    selectedUsers.forEach(u => {
                        u.NewLicenses[l.propertyName] = l.changeState === ActivationStatus.On ? true : (l.changeState === ActivationStatus.Off ? false : null);
                    });
                }
            });

            this._sheet.getUnloadHelper().markEntityChanged();

            const newState: ModuleRightsAppState = {
                licenseInfo,
                licenseSummary,
                selectedUsers,
                userChangeTimestamp,
                userSelectMode
            };

            return newState;
        });
    }

    private _onUserSelectionRadioChange = async (mode: UserFilterType) => {
        if (this.state.userSelectMode !== mode) {
            if (this.state.selectedUsers.length == 0 || await DialogHelper.confirm(this.props.translations.RESET_FILTER)) {
                this._sheet.getUnloadHelper().markEntitySaved();
                this.setState({ userSelectMode: mode, licenseSummary: getLicenseModel(this.state.licenseInfo, null), selectedUsers: [], userChangeTimestamp: Date.now() });
            }
        }
    }

    private _onUserSelectClick = async () => {
        if (this.state.selectedUsers.length === 0) {
            this._openUserSelectWindow();
        } else {
            if (await DialogHelper.confirm(this.props.translations.RESET_FILTER)) {
                this._sheet.getUnloadHelper().markEntitySaved();
                this.setState({ licenseSummary: getLicenseModel(this.state.licenseInfo, null), selectedUsers: [], userChangeTimestamp: Date.now() }, this._openUserSelectWindow);
            }
        }
    }

    private _openUserSelectWindow = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/User?fullObject=true&multi=true&displayPattern=[[name]] ([[name2]])", null, { disableTabTitle: true });
        sheet.setTitle(Config.translations.userSearch);
        sheet.bind(SheetEventType.ItemsSelected, (d: { data: Array<SingleUserFromSearch> }) => {
            const names = d.data.map(u => { return u.name; });
            this._selectData = {
                logins: names,
                groups: [],
                mainGroups: []
            };

            this._loadUserData(names);
        });
    }

    private _loadUserData = (users: Array<string>) => {
        //start a "post" request, because the list of logins could be too big for the current max url length...
        HTTPService.post("Admin/GetAccessRights", { Logins: users })
            .then((result: JsonResultClass<Array<UserCurrentLicenseSummary>>) => {
                if (result.Code === 0) {
                    this._updateDataAfterUsersSelected(null, result.Data);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _onGroupsLoadClick = async (groups: Array<number>, mainGroups: Array<number>) => {
        if (this.state.selectedUsers.length === 0) {
            this._selectData = {
                logins: [],
                groups,
                mainGroups
            };
            this._loadGroupAndMainGroupUsers(groups, mainGroups);
        } else {
            if (await DialogHelper.confirm(this.props.translations.RESET_FILTER)) {
                this._selectData = {
                    logins: [],
                    groups,
                    mainGroups
                };
                this._loadGroupAndMainGroupUsers(groups, mainGroups);
            }
        }
    }

    private _loadGroupAndMainGroupUsers = (groups: Array<number>, mainGroups: Array<number>) => {
        //start a "post" request, because the list of logins could be too big for the current max url length...
        HTTPService.post("Admin/GetAccessRightsForGroups", { Groups: groups, MainGroups: mainGroups })
            .then((result: JsonResultClass<Array<UserCurrentLicenseSummary>>) => {
                if (result.Code === 0) {
                    this._updateDataAfterUsersSelected(null, result.Data);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _doOnMenuSelect = (name: string, mouseButton: MouseButton) => {
        switch (name.toLowerCase()) {
            case "save":
                this._save();
                break;
            default:
                break;
        }
    }

    private _onLicenseHover = (license: ContainedLicense, isEnter: boolean) => {
        if (!license.Expired) {
            const module: ModuleData = Helper.getArrayItem(this.state.licenseSummary, "id", license.Id);
            this._userTableRef.toggleCellsSelection(module.propertyName, isEnter);
        }
    }

    private _onLicenseClick = (license: ContainedLicense) => {
        if (!license.Expired) {
            const module: ModuleData = Helper.getArrayItem(this.state.licenseSummary, "id", license.Id);
            this._userTableRef.toggleCellsForceSelection(module.propertyName, false);

            //remove the selection on the second click
            //(if the user clicks on the currently selected license, don't reselect it -> selection removed)
            if (this._markedModuleName !== module.propertyName) {
                this._markedModuleName = module.propertyName;
                this._userTableRef.toggleCellsForceSelection(module.propertyName, true);
            } else {
                //reset
                this._markedModuleName = null;
            }
        }
    }

    private _onTabActivated = (index: number) => {
        this._rightsTabActive = index === 1;
        this._menuRef.setState({});

        if (index == 0) {
            this._baseUrl = this._baseUrlList[0];
            this.setState({});
        }
        else if (index == 1) {
            this._baseUrl = this._baseUrlList[1];
            this.setState({});
        }
    }

    //end events


    //data & stuff

    //checks if a specific menu button should be enabled or not
    private _enableMenuItem = (action: string | boolean) => {
        if (typeof action === "boolean") {
            return action;
        } else {
            return true;
        }
    }

    //dynamically add the license names as object properties
    private _attachLicenseProperties = (instance: SelectedUser) => {
        this.state.licenseSummary.forEach(l => {
            instance.CurrentLicenses[l.propertyName] = false;
            instance.NewLicenses[l.propertyName] = l.changeState === ActivationStatus.On ? true : (l.changeState === ActivationStatus.Off ? false : null);
        });
    }

    //resets the grid data and generates the new objects, for a new set of selected users (from search)
    private _updateDataAfterUsersSelected = (users: Array<SingleUserFromSearch>, currenInfo: Array<UserCurrentLicenseSummary>) => {
        const userNames = users === null ? [] : users.map(u => { return u.name });
        const newUsers: Array<SelectedUser> = [];
        currenInfo.forEach(ci => {
            if (users === null || userNames.indexOf(ci.Id) !== -1) {
                const newUser = this._addSingleUser(ci);
                newUsers.push(newUser);
            }
        })
        const licenseSummary = getLicenseModel(this.state.licenseInfo, newUsers);

        this._sheet.getUnloadHelper().markEntitySaved();
        this.setState({ selectedUsers: newUsers, licenseSummary, userChangeTimestamp: Date.now() });
    }

    private _addSingleUser = (currenInfo: UserCurrentLicenseSummary) => {
        const tmpUser: SelectedUser = {
            UserName: currenInfo.Id,
            GroupName: currenInfo.GrName,
            GroupNumber: currenInfo.Gr,
            MainGroupName: currenInfo.OGrName,
            MainGroupNumber: currenInfo.OGr,
            CurrentLicenses: {},
            NewLicenses: {},
            AssignedExpiredLicenses: [],
            NotContainedLicenses: []
        };
        this._attachLicenseProperties(tmpUser);

        //currentInfo contains only the active licenses
        if (Array.isArray(currenInfo.Access)) {
            currenInfo.Access.forEach(s => {
                const licenseIdx = Helper.findObjIndex(this.state.licenseSummary, "id", s.Id);
                if (licenseIdx !== -1) {
                    const licPropName = this.state.licenseSummary[licenseIdx].propertyName
                    //if the license is present, it's active for the current user
                    tmpUser.CurrentLicenses[licPropName] = true;
                } else {
                    const expired = Helper.getArrayItem(this.state.licenseInfo.ExpiredLicenses, "Id", s.Id);
                    if (expired) {
                        tmpUser.AssignedExpiredLicenses.push(s.Id);
                    } else {
                        tmpUser.NotContainedLicenses.push(s.Id);
                    }
                }
            });
        }



        return tmpUser;
    }

    private _getDataToSave = () => {
        const data: Array<SaveAccessRightsModel> = [];
        const containedModules: Array<number> = this.state.licenseInfo.ContainedLicenses.map(l => l.Id);

        this.state.selectedUsers.forEach(user => {
            const sarm: SaveAccessRightsModel = {
                Modules: [],
                UserName: user.UserName
            };

            this.state.licenseSummary.forEach(lic => {
                if (lic.dirty) {
                    if (user.NewLicenses[lic.propertyName] === true) {
                        sarm.Modules.push(lic.id);
                    }
                } else {
                    if (user.CurrentLicenses[lic.propertyName] === true) {
                        sarm.Modules.push(lic.id);
                    }
                }

                //if the user changed the value of the license, check the value from the NewLicenses property,
                //if the license value was not changed, keep the original value
                //const activeValue = lic.dirty? user.NewLicenses[lic.propertyName] : user.CurrentLicenses[lic.propertyName]

                //if (activeValue === true) {
                //    //the license value was changed and the license is active => add it to the list
                //    sarm.Access.push(licInst);
                //}
            });



            user.AssignedExpiredLicenses.forEach(id => sarm.Modules.push(id));

            data.push(sarm);
        });

        return data;
    }

    //saves the changes
    private _save = () => {
        if (this._sheet.hasUnsavedChanges()) {
            const data = this._getDataToSave();
            HTTPService.post<JsonResultClass>("Admin/SaveAccessRights", data)
                .then(result => {
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(this.props.translations.MOD_MSG_SAVED);
                        HTTPService.get<JsonResultClass<CurrentLicensePackageInformation>>("Admin/GetLicenseInformation")
                            .then(result => {
                                this._sheet.getUnloadHelper().markEntitySaved();
                                this.setState({ licenseInfo: result.Data, userChangeTimestamp: new Date().getTime(), selectedUsers: [], licenseSummary: getLicenseModel(result.Data, null), }, () => {
                                    if (this.state.userSelectMode === UserFilterType.SingleUser) {
                                        this._loadUserData(this._selectData.logins);
                                    } else if (this.state.userSelectMode === UserFilterType.Groups) {
                                        this._loadGroupAndMainGroupUsers(this._selectData.groups, this._selectData.mainGroups);
                                    }
                                });
                            });
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }

    //end data & stuff

    render() {
        return (
            <>
                {this._renderRightDrawerComponent()}
                <VerticalTabStrip
                    titles={[this.props.translations.INDEX_NAVBAR_LICINFO, this.props.translations.INDEX_NAVBAR_MODULERIGHTS]}
                    onTabActivated={this._onTabActivated}
                >
                    <div>
                        <LicenseInformationSummary
                            translations={this.props.translations}
                            licensePackage={this.state.licenseInfo}
                            users={this.props.users}
                        />
                    </div>
                    <div>
                        <div className="flex-container">
                            <div style={{ flexShrink: 0, marginBottom: "15px" }}>
                                {renderRegion(this.props.translations.ACCESSIBLE_MODULES, this._renderLicenseTable())}
                            </div>
                            <UserSelection
                                groups={this.props.groupData.Groups}
                                mainGroups={this.props.groupData.MainGroups}
                                onRadioChange={this._onUserSelectionRadioChange}
                                onUserSelectClick={this._onUserSelectClick}
                                onGroupsLoadClick={this._onGroupsLoadClick}
                                translations={this.props.translations}
                                userSelectMode={this.state.userSelectMode}
                            />
                            <UserTable
                                translations={this.props.translations}
                                licenses={this.state.licenseSummary}
                                users={this.state.selectedUsers}
                                ref={this._onUserTableRef}
                            />
                        </div>
                    </div>
                    <VerticalTabsStripFloatingContent>
                        <Menu entries={this._menuDataSource} onSelect={this._doOnMenuSelect} enableMenuItem={this._enableMenuItem} ref={this._onMenuRef} handleEval={null} />
                        <PageTitle title={this.props.title} />
                    </VerticalTabsStripFloatingContent>
                </VerticalTabStrip>
            </>
        );
    }
}

export interface ModuleRightsAppProps {
    title: string;
    metadata?: Metadata;
    licenseInfo: CurrentLicensePackageInformation;
    users: Array<{ Logins: number; Name: string; }>
    translations: AdminModuleTranslations;
    groupData: {
        Groups: Array<{ Id: number; Name: string; }>;
        MainGroups: Array<{ Id: number; Name: string; }>;
    }
}

interface ModuleRightsAppState {
    selectedUsers: Array<SelectedUser>;
    userSelectMode: UserFilterType;
    licenseSummary: Array<ModuleData>;
    userChangeTimestamp: number;
    licenseInfo: CurrentLicensePackageInformation;
}


class UserSelection extends React.Component<UserSelectionProps, UserSelectionState> {
    private labelStyle: React.CSSProperties = {
        marginRight: "10px"
    };
    private _componentFactory = ComponentHelper.createFactory();
    private _groupSelectProps: MultiSelectProps = null;
    private _mainGroupSelectProps: MultiSelectProps = null;
    private _groups: Array<{ Id: number; Name: string; }> = [];
    private _mainGroups: Array<{ Id: number; Name: string; }> = [];

    constructor(props) {
        super(props)
        this._initApp();
    }

    private _onRadioChange = (mode: UserFilterType) => {
        this.props.onRadioChange(mode);
        //if (!ev.isDefaultPrevented()) {
        //    //current select mode is groups -> will be changed => reset the values
        //    if (this.props.userSelectMode === UserFilterType.Groups) {
        //        this._groups.length = 0;
        //        this._mainGroups.length = 0;
        //    }
        //}
    }

    private _onGroupChange = (field, value, item) => {
        Helper.setArrayValues(this._groups, value);
    }

    private _onMainGroupChange = (field, value, item) => {
        Helper.setArrayValues(this._mainGroups, value);
    }

    private _onUserSelectClick = (button: ToolBarStandardButtonType) => {
        this.props.onUserSelectClick();
    }

    private _onGroupsLoadClick = (buttonId: string) => {
        if (buttonId === "groupLoad" && (this._groups.length > 0 || this._mainGroups.length > 0)) {
            this.props.onGroupsLoadClick(this._groups.map(g => { return g.Id; }), this._mainGroups.map(g => { return g.Id; }));
        }
    }


    private _initApp = () => {
        this._groupSelectProps = this._componentFactory.getDefaultMultiSelectProps();
        this._groupSelectProps.field.model = "group";
        this._groupSelectProps.dataSource = this.props.groups;
        this._groupSelectProps.field.dataTextField = "Name";
        this._groupSelectProps.field.dataValueField = "Id";
        this._groupSelectProps.onChange = this._onGroupChange;
        this._groupSelectProps.onDataLoaded = () => { };
        this._groupSelectProps.style = {
            width: "auto",
            minWidth: "300px"
        };
        this._groupSelectProps.value = this._groups;

        this._mainGroupSelectProps = this._componentFactory.getDefaultMultiSelectProps();
        this._mainGroupSelectProps.field.model = "maingroup";
        this._mainGroupSelectProps.dataSource = this.props.mainGroups;
        this._mainGroupSelectProps.field.dataTextField = "Name";
        this._mainGroupSelectProps.field.dataValueField = "Id";
        this._mainGroupSelectProps.onChange = this._onMainGroupChange;
        this._mainGroupSelectProps.onDataLoaded = () => { };
        this._mainGroupSelectProps.style = {
            width: "auto",
            minWidth: "300px"
        };
        this._mainGroupSelectProps.value = this._mainGroups;
    }

    render() {
        const userBtns: Array<ToolBarStandardButton> = [
            {
                caption: Config.translations.select,
                enabled: true,
                type: ToolBarStandardButtonType.NEW
            }
        ];
        const groupsBtns: Array<ToolBarCustomButton> = [
            {
                caption: Config.translations.loadLabel,
                enabled: true,
                iconClass: "k-i-plus",
                id: "groupLoad"
            }
        ];

        const filterStyle: React.CSSProperties = {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap"
        };

        return (
            <div style={{ flexShrink: 0 }}>
                <div className="" style={{ display: "flex", paddingLeft: "10px" }}>
                    <SimpleRadioButton
                        label={this.props.translations.USER_SELECTION}
                        onChange={(v, e) => this._onRadioChange(UserFilterType.SingleUser)}
                        value={this.props.userSelectMode === UserFilterType.SingleUser}
                        name="userFilterSelection"
                        labelStyle={this.labelStyle}
                    />
                    <SimpleRadioButton
                        label={this.props.translations.GROUPS_SELECTION}
                        onChange={(v, e) => this._onRadioChange(UserFilterType.Groups)}
                        value={this.props.userSelectMode === UserFilterType.Groups}
                        name="userFilterSelection"
                        labelStyle={this.labelStyle}
                    />
                </div>
                <div className="" style={{ display: "flex", marginBottom: "10px", alignItems: "center", flexWrap: "wrap", paddingLeft: "10px" }}>
                    {
                        this.props.userSelectMode === UserFilterType.SingleUser ?
                            <div style={filterStyle}>
                                <label style={{ flexShrink: 0 }}>{this.props.translations.LBL_USERS}:</label>&nbsp;&nbsp;<ToolBar standardButtons={userBtns} handleStandardButtonClick={this._onUserSelectClick} />
                            </div>
                            : null
                    }
                    {
                        this.props.userSelectMode === UserFilterType.Groups ?

                            <div style={filterStyle}>
                                <label style={{ flexShrink: 0 }}>{this.props.translations.LBL_GROUPS}:</label>&nbsp;&nbsp;<MultiSelect {...this._groupSelectProps} />
                            </div>
                            : null
                    }
                    &nbsp;&nbsp;
                    {
                        this.props.userSelectMode === UserFilterType.Groups ?
                            <div style={filterStyle}>
                                <label style={{ flexShrink: 0 }}>{this.props.translations.LBL_MAIN_GROUPS}:</label>&nbsp;&nbsp;<MultiSelect {...this._mainGroupSelectProps} />
                            </div>
                            : null
                    }
                    &nbsp;&nbsp;
                    {
                        this.props.userSelectMode === UserFilterType.Groups ?
                            <ToolBar customButtons={groupsBtns} handleCustomButtonClick={this._onGroupsLoadClick} />
                            : null
                    }
                </div>
            </div>
        );
    }
}

interface UserSelectionProps {
    onRadioChange: (mode: UserFilterType) => void;
    groups: Array<{ Id: number; Name: string; }>;
    mainGroups: Array<{ Id: number; Name: string; }>;
    onUserSelectClick: () => void;
    onGroupsLoadClick: (groups: Array<number>, mainGroups: Array<number>) => void;
    translations: AdminModuleTranslations;
    userSelectMode: UserFilterType
}

interface UserSelectionState {

}


class UserTable extends React.Component<UserTableProps, UserTableState> {
    private _gridElementRef = null;
    private _gridRef: kendo.ui.Grid = null;
    private _gridOptions: kendo.ui.GridOptions = null;
    private _currenUsers: Array<SelectedUser> = null;


    constructor(props: UserTableProps) {
        super(props);
        this.state = {
            users: []
        };
        this._setGridOptions();
    }


    private _onGridRef = (ref) => {
        this._gridElementRef = ref;
    }

    private _updateGridData = () => {
        this._gridRef.dataSource.data(this.props.users);
        this._gridRef.dataSource.page(1);
    }


    public toggleCellsSelection = (prop: string, on: boolean) => {
        $("tr td .force-hover:not(.force-select)", this._gridRef.tbody).removeClass("force-hover");
        if (on) {
            $("tr td [data-prop=" + prop + "]", this._gridRef.tbody).addClass("force-hover");
        }
    }

    public toggleCellsForceSelection = (prop: string, on: boolean) => {
        $("tr td .force-select", this._gridRef.tbody).removeClass("force-select");
        if (on) {
            $("tr td [data-prop=" + prop + "]", this._gridRef.tbody).addClass("force-hover force-select");
        }
    }


    private _setGridOptions = () => {
        this._gridOptions = {
            selectable: true,
            resizable: true,
            sortable: true,
            scrollable: true,
            pageable: true,
            columns: [
                {
                    field: "UserName",
                    title: this.props.translations.LBL_USER,
                    width: 100
                },
                {
                    field: "MainGroupName",
                    title: this.props.translations.MAIN_GROUP,
                    width: 100
                },
                {
                    field: "GroupName",
                    title: this.props.translations.GROUP,
                    width: 100
                }
            ],
            dataSource: {
                pageSize: 100,
                data: this.state.users
            },
            dataBound: (e) => {
                //if (this._gridData.length > 0 && Helper.hasValue(this._markedModuleName)) {
                //    this._forceSelectGridCells(this._markedModuleName);
                //}
            }
        };

        //muss nach _initLicenseModel kommen...
        this.props.licenses.forEach(l => {
            this._gridOptions.columns.push({
                title: l.name,
                headerAttributes: {
                    style: "text-align: center;"
                },
                columns: [
                    {
                        title: this.props.translations.MOD_GRID_CURRENT,
                        template: getCellTemplate("CurrentLicenses." + l.propertyName, true),
                        width: 60,
                        attributes: {
                            style: "text-align: center;"
                        }
                    },
                    {
                        title: this.props.translations.MOD_GRID_CHANGED,
                        template: getCellTemplate("NewLicenses." + l.propertyName, false),
                        width: 60,
                        attributes: {
                            style: "text-align: center;"
                        }
                    },
                ]
            });
        });
    }

    componentDidMount() {
        this._gridRef = $(this._gridElementRef).kendoGrid(this._gridOptions).data("kendoGrid");
    }

    componentDidUpdate() {
        //if (this.props.users !== this._currenUsers) {
        //    this._currenUsers = this.props.users;
        this._updateGridData();
        //}
    }

    render() {
        return (
            <div className="flex-container__item flex-container" style={{ minHeight: "300px" }} ref={this._onGridRef}></div>
        );
    }
}

interface UserTableProps {
    translations: AdminModuleTranslations;
    licenses: Array<ModuleData>
    users: Array<SelectedUser>;
}

interface UserTableState {
    users: Array<SelectedUser>;
}


class LicenseInformationSummary extends React.Component<LicenseInformationSummaryProps, LicenseInformationSummaryState> {

    private _renderContainedLiceses = (renderExpired = false) => {
        const licenses = renderExpired ? this.props.licensePackage.ExpiredLicenses : this.props.licensePackage.ContainedLicenses
        const expireText = renderExpired ? "Expired on" : "Expires on";
        return (
            <ul style={{ listStyle: "none", paddingLeft: "0" }}>
                {
                    licenses.map((l, lIdx) => {
                        return (
                            <li style={{ color: renderExpired ? "red" : null }} key={lIdx}>
                                {l.Amount} x {l.Name} {Helper.hasValue(l.ExpirationDate) ? ` (***${expireText}***: ${Helper.dates.toString(Helper.dates.toDate(l.ExpirationDate))})` : null}
                            </li>
                        );
                    })
                }
            </ul>
        );
    }

    private _renderRegionField = (label: string, content: any, key: number, alignTop = true) => {
        return (
            <div key={key} style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                <label style={{ width: "40%", display: "inline-flex", alignItems: alignTop ? "flex-start" : "center", justifyContent: "flex-end", marginBottom: "0" }}>{label}</label>
                <div style={{ width: "57%", whiteSpace: "pre-wrap" }}>{content}</div>
            </div>
        );
    }

    private _renderInfo = () => {
        const fields = [];

        fields.push(this._renderRegionField(this.props.translations.LIC_INF_PACKAGE_NR, this.props.licensePackage.Number.toString(), 1));
        fields.push(this._renderRegionField(this.props.translations.LIC_INF_PACKAGE_NAME, this.props.licensePackage.Name, 2));
        fields.push(this._renderRegionField(this.props.translations.LIC_INF_PACKAGE_LICENSEE, this.props.licensePackage.Licensee, 3));
        fields.push(this._renderRegionField(this.props.translations.LIC_INF_PACKAGE_CONTAINED_LICENSES, this._renderContainedLiceses(), 5));
        if (this.props.licensePackage.ExpiredLicenses.length > 0) {
            fields.push(this._renderRegionField("***Expired licenses***", this._renderContainedLiceses(true), 6));
        }

        return fields;
    }

    private _renderCurrentLoad = () => {
        return this.props.licensePackage.ContainedLicenses.map((lic, sIdx) => {
            return this._renderRegionField(lic.Name + ":", Helper.processTemplate(this.props.translations.LIC_INF_CURRENT_USAGE, (match) => {
                if (match === "usage") {
                    return Helper.hasValue(lic.CurrentLoad) ? lic.CurrentLoad.toString() : "0";
                } else if (match === "amount") {
                    return Helper.hasValue(lic.Amount) ? lic.Amount.toString() : "0";
                }
            }), sIdx);
        });
    }

    private _renderUsers = () => {
        return (
            <ul style={{}}>
                {
                    this.props.users.map((user, uIdx) => {
                        var count = user.Logins > 1 ? "(" + user.Logins + "x)" : null;
                        return <li key={uIdx}>{user.Name} {count}</li>;
                    })
                }
            </ul>
        );
    }


    render() {
        return (
            <>
                {renderRegion(this.props.translations.LIC_INF_PACKAGE_HEADER, this._renderInfo())}
                {renderRegion(this.props.translations.LIC_INF_USAGE_HEADER, this._renderCurrentLoad())}
                {renderRegion(this.props.translations.LIC_INF_USERS_HEADER, this._renderUsers())}
            </>
        );
    }
}

interface LicenseInformationSummaryProps {
    licensePackage: CurrentLicensePackageInformation;
    translations: AdminModuleTranslations;
    users: Array<{ Logins: number; Name: string; }>
}

interface LicenseInformationSummaryState {

}


enum UserFilterType {
    NotSet, SingleUser, Groups
}

interface SelectedUser {
    UserName: string;
    GroupName: string;
    GroupNumber: number;
    MainGroupName: string;
    MainGroupNumber: number;
    CurrentLicenses: StringKeyDictionary<boolean>;
    NewLicenses: StringKeyDictionary<boolean>;
    AssignedExpiredLicenses: Array<number>;
    NotContainedLicenses: Array<number>;
}

interface ModuleData {
    id: number;
    name: string;
    //enabled: boolean;
    propertyName: string;
    initialInstances: {
        active: number;
        notActive: number;
    };
    changeState: ActivationStatus;
    dirty: boolean;
}

interface SingleUserFromSearch {
    name: string;
    //maybe later...
    //name2: string;
    grnr: number;
    gruppe: string;
    ogrnr: number;
    obergruppe: string;
}

interface UserCurrentLicenseSummary {
    Gr: number;
    GrName: string;
    OGr: number;
    OGrName: string;
    Id: string;
    Access: Array<{ Id: number }>;
}

interface SaveAccessRightsModel {
    UserName: string;
    Modules: Array<number>;
}

interface AdminModuleTranslations {
    // Übersetzungen Hauptseite:
    INDEX_TOGGLE_NAVIGATION: string;
    INDEX_NAVBAR_HEADER: string;
    INDEX_NAVBAR_LICINFO: string;
    INDEX_NAVBAR_MODULERIGHTS: string;

    // Übersetzungen diverser Nachrichten:
    LOADING: string;
    NOT_AUTHORIZED: string;
    CONNECTION_LOST: string;
    CONNECTION_REESTABLISHED: string;
    RESOURCE_NOT_FOUND: string;
    INTERNAL_SERVER_ERROR: string;
    UNKNOWN_ERROR: string;

    // Übersetzungen Modulberechtigungen:
    MOD_RIGHTS_SEARCH: string;
    MOD_BUTTON_SAVE: string;
    MOD_BUTTON_UNDO: string;
    MOD_BUTTON_REDO: string;

    MOD_RIGHTS_ACTIVATE_ON_LOGIN: string;
    MOD_RIGHTS_HEADER: string;

    MOD_MSG_SAVED: string;
    MOD_MSG_NOT_SAVED: string;
    MOD_MSG_COULD_NOT_LOAD_DATA: string;
    MOD_MSG_COULD_NOT_LOAD_TRANSLATIONS: string;

    MOD_CONTENT_SEARCH_HEADER: string;

    ALL_MAIN_GROUPS: string;
    MAIN_GROUPS: string;
    ALL_GROUPS: string;
    GROUPS: string;
    NOT_ASSIGNED: string;
    USERS: string;
    MOD_RIGHTS_EMPTY: string;

    // Übersetzungen Lizenzinformation:
    LIC_INF_PACKAGE_HEADER: string;
    LIC_INF_PACKAGE_NR: string;
    LIC_INF_PACKAGE_NAME: string;
    LIC_INF_PACKAGE_LICENSEE: string;
    LIC_INF_PACKAGE_EXPIRE_DATE: string;
    LIC_INF_PACKAGE_CONTAINED_LICENSES: string;
    LIC_INF_USAGE_HEADER: string;
    LIC_INF_USERS_HEADER: string;
    LIC_INF_CURRENT_USAGE: string;

    LR_CONCURRENTLOGINS: string;
    LR_UNLIMITEDLOGINS: string;

    MOD_GRID_IS_ACTIVE: string;
    MOD_GRID_CHANGED: string;
    MOD_GRID_CURRENT: string;
    MOD_GRID_AT_LOGIN: string;
    RESET_FILTER: string;
    USER_SELECTION: string;
    GROUPS_SELECTION: string;
    ACCESSIBLE_MODULES: string;
    GROUP: string;
    MAIN_GROUP: string;
    LBL_GROUPS: string;
    LBL_MAIN_GROUPS: string;
    LBL_USERS: string;
    LBL_USER: string;
    LBL_ON: string;
    LBL_OFF: string;
    LBL_EXPIRED_LICENSES: string;
}

